/*global google*/
var _module = require('../../module');
var $ = require('jquery');

require('../../google-search-autocomplete');

_module.component('homesearch', {
    bindings: {
        onSearch: '&'
    },
    controllerAs: 'homesearch',
    controller: [
        '$log',
        '$timeout',
        '$mdMedia',

        function homesearchCtrl($log, $timeout, $mdMedia) {
            var _this = this;

            this.search = '';

            // Functions
            this.onFormSubmit = function onFormSubmit() {
                if(_this.search) {
                    $timeout(function onFormSubmitTO() {
                        _this.onSearch({ $value: _this.search, $latLng: _this.latLng });
                    }, 200);
                }
            };

            this.backtoTop = function backtoTop() {
                if($mdMedia('xs')) {
                    $('html, body').animate({ scrollTop: 0 }, 250);
                }
            };
        }
    ],
    template: require('./index.html')
});
